import React from 'react'
import './WhyHireUs.css'
import WhuImg from '../../../../assets/img/whu.webp'
import pd from '../../../../assets/img/project_delivered.svg'
import hc from '../../../../assets/img/happy_clients.svg'
import tc from '../../../../assets/img/coffee.svg'
import CountUpOnScroll from '../../Home/About/ScrollCounter'

function WhyHIreUs() {
  return (
    <section className='whu-sec'>
        <div className='container'>
            <div className='whu-sec1'>
                <div className='whulft'></div>
                <div className='whurgt'>
                    <h3>What We Offer</h3>
                    <ul>
                        <li> Custom storefront and marketplace platforms </li>
                        <li> Payment gateway integration and subscription commerce </li>
                        <li> Headless commerce and progressive web app (PWA) storefronts </li>
                        <li> Inventory, order management, and logistics integrations </li>
                        <li> Omnichannel commerce: web, mobile, in-store sync </li>
                    </ul>
                    
                </div>
            </div>
        </div>
    </section>
  )
}

export default WhyHIreUs
